export default __webpack_public_path__ + "static/media/tiger_mark.41b08efe.png";